import React from 'react'
import PagosCursos from '../components/pagosCursos/pagosCursos';
export default function MisPagosCursos () {
  return <section className="registro-convocatoria">
    <PagosCursos />
  </section>
}
